module.exports = __webpack_public_path__ + "static/media/second-enterprise-plan.b3858ea3.png";